import React from "react";
import "../styles/EditStudentModal.css";

// Helper to get session year (used for auto-calculation if needed)
function getSessionYear(batchName, classNum) {
  if (!batchName) return "";
  const parts = String(batchName).split("-");
  const startYear = parseInt(parts[0], 10);
  if (isNaN(startYear)) return batchName;
  const s = startYear + (classNum - 1);
  const e = (parseInt(parts[1], 10) || (startYear + 1)) + (classNum - 1);
  return `${s}-${String(e).slice(-2)}`;
}

const GNM_CLASSES = [
  { value: 1, label: "1st Year GNM" },
  { value: 2, label: "2nd Year GNM" },
  { value: 3, label: "3rd Year GNM" }
];

const CATEGORY_LIST = [
  { value: "OPEN", label: "Open" },
  { value: "ST", label: "ST" },
  { value: "NT", label: "NT" },
  { value: "OBC", label: "OBC" },
  { value: "VJNT", label: "VJNT" },
  { value: "SBC", label: "SBC" },
  { value: "SC", label: "SC" }
];

export default function EditStudentModal({
  show,
  form,
  handleChange,
  handleEditStudentUpdate,
  handleEditStudentSaveClose,
  handleEditStudentCancel,
  handleEditStudentDelete,
  mode = "edit",
  error = ""
}) {
  if (!show || !form) return null;

  // Session year for display only (not editable)
  const batchName = form.session_year || "";
  const classYear = Number(form.course_year) || 1;
  const displaySessionYear = getSessionYear(batchName, classYear);

  return (
    <div className="student-modal">
      <form className="student-form" onSubmit={handleEditStudentUpdate}>
        <h4>{mode === "add" ? "Add Student" : "Edit Student"}</h4>
        <div className="student-form-group">
          <label htmlFor="name">Name</label>
          <input id="name" name="name" value={form.name || ""} onChange={handleChange} required />
        </div>
        <div className="student-form-group">
          <label htmlFor="email">Email</label>
          <input id="email" name="email" value={form.email || ""} onChange={handleChange} required />
        </div>
        <div className="student-form-group">
          <label htmlFor="dob">Date of Birth</label>
          <input id="dob" name="dob" value={form.dob || ""} onChange={handleChange} type="date" required />
        </div>
        <div className="student-form-group">
          <label htmlFor="address">Address</label>
          <input id="address" name="address" value={form.address || ""} onChange={handleChange} />
        </div>
        <div className="student-form-group">
          <label htmlFor="category">Category</label>
          <select
            id="category"
            name="category"
            value={form.category || "OPEN"}
            onChange={handleChange}
            required
          >
            {CATEGORY_LIST.map(c => (
              <option key={c.value} value={c.value}>{c.label}</option>
            ))}
          </select>
        </div>
        {/* Batch / Session Year is now READ-ONLY and always matches session_year */}
        <div className="student-form-group">
          <label>Batch / Session Year</label>
          <input value={form.session_year || ""} readOnly style={{ background: "#e9ecef" }} />
        </div>
        <div className="student-form-group">
          <label htmlFor="course_year">Class / Year</label>
          <select
            id="course_year"
            name="course_year"
            value={form.course_year || ""}
            onChange={handleChange}
            required
          >
            {GNM_CLASSES.map((c) => (
              <option key={c.value} value={c.value}>{c.label}</option>
            ))}
          </select>
        </div>
        <div className="student-form-group">
          <label>Session Year (Auto)</label>
          <input value={displaySessionYear} readOnly style={{ background: "#e9ecef" }} />
        </div>
        <div className="student-form-group">
          <label htmlFor="roll_no">Roll No</label>
          <input id="roll_no" name="roll_no" value={form.roll_no || ""} onChange={handleChange} required />
        </div>
        {error && <div className="student-form-error">{error}</div>}
        <div className="student-form-actions">
          {mode === "edit" ? (
            <>
              <button type="submit" className="student-btn student-btn-update">Update</button>
              <button type="button" className="student-btn student-btn-update" style={{marginLeft: "8px"}} onClick={handleEditStudentSaveClose}>Save &amp; Close</button>
              <button type="button" className="student-btn student-btn-delete" style={{marginLeft: "8px"}} onClick={handleEditStudentDelete}>Delete</button>
            </>
          ) : (
            <>
              <button type="submit" className="student-btn student-btn-update">Add</button>
            </>
          )}
          <button type="button" className="student-btn student-btn-cancel" onClick={handleEditStudentCancel}>Cancel</button>
        </div>
      </form>
    </div>
  );
}